import React from 'react';

/**
 * Component to inject gradient animation styles into the document head
 * This component renders a style tag with the CSS animation definitions
 */
export const GradientAnimationStyles: React.FC = () => (
  <style dangerouslySetInnerHTML={{ 
    __html: `
      @keyframes gradientAnimation {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
      
      .gradient-animation {
        background-size: 200% 200%;
        animation: gradientAnimation 3s ease-in-out infinite;
      }
    `
  }} />
);

export default GradientAnimationStyles;
